import React, { FormEventHandler, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import * as UI from '../common';
import { Alert } from 'flowbite-react';
import { InputComponent } from '../core/Forms';
import { useUserStore } from '../../state/useUserStore';
import { validateLoginForm } from '../../modules/auth/login';
import { clearFieldError } from '../../utils/handleErrors';
import {useCognitoLogin} from "../../hooks";


interface Props {}

const LoginView: React.FC<Props> = () => {
  const { authenticateUser, isLoading, errorMessage: message } = useCognitoLogin();
  const navigate = useNavigate();
  const [errorFound] = useState(false);

  const { setUser } = useUserStore();

  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const [validationResults, setValidationResults] = useState({
    email: '',
    password: '',
  });

  const handleInputChange = (event: any) => {
    const { name, value } = event.target;
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    validateForm();
    clearFieldError(name, validationResults, setValidationResults);
  };
  
  
  
  

  const validateForm = () => {
    const errors = validateLoginForm(formData);
    setValidationResults(errors);
  };

  const handleSignIn: FormEventHandler<HTMLFormElement> = async (e) => {
  e.preventDefault();
  validateForm();
  if (!errorFound) {
    console.log('Data sent during login:', formData);
    const response: any = await authenticateUser(formData.email, formData.password);

    const { firstName, lastName, email, phone, address } = response;

    const user = {
      fullName: `${firstName} ${lastName}`,
      email,
      phone,
      address,
    };

    setUser(user);
    navigate('/businessLayout');
  }
};

  
  return (
    <div className="bg-[#F2F9FD]">
      <div className="flex justify-center items-center">
        {message ? (
          <Alert className="text-center w-1/2" color="failure">
            {message}
          </Alert>
        ) : null}
      </div>

      <div className="xl:pb-[19.05px]  xl:text-center  ">
        <h1 className="text-[20px] text-center pb-[2px] font-bold md:text-[28px] xl:text-[28px]  xl:pb-[2px] xl:font-bold 2xl:ml-[-2em]">Hi there, Welcome back</h1>
        <p className="text-[14px] mt-[1em] text-center font-light md:text-[16px] md:font-normal xl:pb-[16px] xl:text-[16px] 2xl:ml-[-2em]">Sign in to continue productivity</p>
        <button className="flex justify-center mx-auto  md:ml-[11.5em] bigmd:ml-[14.5em]  biglg:ml-[5em]   mt-[1em] py-2 px-4 w-full md:w-[400px] gap-2 rounded-md bg-white h-[48px] border border-[#A4A4A4] lg:ml-[1em] xl:px-4 xl:w-[400px] xl:h-[48px] xl:flex xl:gap-2 xl:mx-auto xl:justify-center xl:py-2 xl:rounded-md xl:bg-white xl:border xl:border-[#A4A4A4] xl:text-black xl:font-bold xl:ml-[9em] 2xl:ml-[8em]">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg"
            alt="Google logo"
            className="w-5 h-5 inline-block xl:inline-block xl:h-6 xl:w-6"
          />
          <p className="xl:text-[16px] xl:font-medium"> Sign in with Google</p>
        </button>
      </div>
      <div className=" xl:flex-col xl:items-center xl:justify-center xl:min-h-screen ">
        <div className="xl:w-full xl:px-6 xl:rounded-xl ">
          <form onSubmit={handleSignIn}>
            <div className="mt-[2em] xl:mt-[6px]">
              <div className="mt-[1em] rounded-md md:ml-[10.5em] bigmd:ml-[13em] md:mt-[2em] lg:ml-[0.2em] biglg:ml-[4em]  xl:flex xl:justify-center xl:placeholder:text-[16px] xl:h-[48px] xl:mt-[30px] xl:ml-[3em] 2xl:ml-[-4em] ">
                <div className=" xl:rounded xl:p-1 xl:w-[434px] xl:mb-[16px]">
                  <label htmlFor="Email" className="xl:block xl:font-sm xl:text-[13px] md:text-[13px] xl:text-black text-[12px]">
                    Email
                  </label>
                  <InputComponent
                    placeholder="Email"
                    name="email"
                    type="text"
                    value={formData.email}
                    handleChange={handleInputChange}
                    error={validationResults.email}
                    className="w-full rounded-md  md:w-[434px] lg:w-[434px] xl:w-[434px]"
                  />
                </div>
              </div>
              <div className="mt-[1em] rounded-md md:mt-[2em] md:ml-[10.5em] bigmd:ml-[13em] biglg:ml-[4em] lg:ml-[0.2em] xl:flex xl:justify-center xl:placeholder:text-[16px] xl:h-[48px] xl:mt-[39px] xl:ml-[3em] 2xl:ml-[-4em] ">
                <div className=" xl:rounded xl:p-1 xl:w-[434px] xl:mb-[16px]">
                  <label htmlFor="Password" className="xl:block xl:font-sm xl:text-[13px] xl:text-black text-[12px]  md:text-[13px]">
                    Password
                  </label>
                  <InputComponent
                    placeholder="Password"
                    name="password"
                    type="password"
                    value={formData.password}
                    handleChange={handleInputChange}
                    error={validationResults.password}
                    className="w-full rounded-md md:w-[434px] xl:w-[434px]"
                    imageClassName="ml-[21em] 375:ml-[19em]  414:ml-[21em] 360:ml-[18em] 412:ml-[21.5em] mt-[-5em] md:ml-[24em] md:mt-[-5.5em]  lg:ml-[25em] lg:mt-[-5em] xl:ml-[25em] xl:mt-[-5em] 540:ml-[29em] 540:mt-[-4.5em]"
                  />

                  <div className="mb-[1em] ml-[8em] md:ml-[10em] biglg:ml-[11em]  lg:ml-[10em] xl:ml-[-1em] xl:mt-[-1em]  xl:flex xl:justify-center xl:py-[31px]">
                    <div></div>
                    <Link
                      to="/auth/forget-password"
                      className="text-[11px] text-blue-700 xl:flex xl:text-center xl:py-[13px] xl:pb-[26px] xl:font-sans xl:font-italic xl:font-semibold xl:text-base xl:leading-none xl:underline xl:text-blue-700"
                    >
                      Forgot Password?{' '}
                    </Link>
                  </div>
                </div>
              </div>

              <div className="w-full  md:w-[434px] md:ml-[10.5em] bigmd:ml-[13em] biglg:ml-[4em] lg:ml-[0.2em] xl:h-[48px] xl:flex xl:mt-[3em] xl:w-full xl:justify-center xl:py-[41px] xl:ml-[2em] 2xl:ml-[-2em]">
                <div className="xl:w-[434px] xl:mt-[40px]">
                  <UI.Button text="Log in" isLoading={isLoading} />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export { LoginView };
